import useAccountManagementStore from "../stores/accountManagementStore";
import useTextFilesStore from "../stores/textFilesStore";
import getTextFilesForUser from "./backend/text_buckets/getTextFilesForUser";
import uploadTextFile from "./backend/text_buckets/uploadTextFile";
import { MergeResult } from "./mergeTableData";

/**
 * Update the text files in the cloud by comparing the local data with the cloud data.
 * If the cloud does not have a local text file, add it.
 * If a local file is newer, upload it.
 * @param {MergeResult} data - The result of the merge operation.
 */
export default function updateTextFilesCloud(data: MergeResult) {
    const userData = useAccountManagementStore.getState().userData;

    // Get text files that exist in cloud
    getTextFilesForUser().then((cloudTextFiles) => {
        if (!cloudTextFiles) return;

        const noteIDToUpload: string[] = [];
        const localTextFiles = Object.values(data.data.notes);

        // If cloud does not have local text file, add it
        localTextFiles.forEach((note) => {
            if (
                !cloudTextFiles.includes(note.id) &&
                !data.data.deleted.notes.includes(note.id)
            ) {
                noteIDToUpload.push(note.id);
            }
        });

        // If local file is newer, upload it
        Object.values(data.conflicts.localNewer.notes).forEach((note) => {
            if (
                !noteIDToUpload.includes(note.id) &&
                !data.data.deleted.notes.includes(note.id)
            ) {
                noteIDToUpload.push(note.id);
            }
        });

        // Upload text files that need to be uploaded to cloud
        noteIDToUpload.forEach((noteID) => {
            console.log("Upload note to Supabase: ", noteID);

            useTextFilesStore
                .getState()
                .getTextFile(noteID)
                .then((textFile) =>
                    uploadTextFile(noteID, textFile.content)
                );
        });
    });
}
